import { Component, Input, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { Rekbot } from '../../models/rekbot.model';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { combineLatest, map, Observable, of, startWith } from 'rxjs';
import { RekbotsService } from '../../services/rekbots.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule, NgFor } from '@angular/common';
import { RekbotCardSmallComponent } from '../rekbot-card-small/rekbot-card-small.component';
import { MatChipsModule } from '@angular/material/chips';
import { RekbotSelectsService } from '../../services/rekbot-selects.service';


@Component({
  selector: 'app-user-rekbot-list-small',
  imports: [
    MatCardModule,
    MatIconModule,
    CommonModule,
    ReactiveFormsModule,
    NgFor,
    //RekbotCardSmallComponent,
    MatChipsModule,
    ReactiveFormsModule
  ],
  templateUrl: './user-rekbot-list-small.component.html',
  styleUrl: './user-rekbot-list-small.component.css'
})
export class UserRekbotListSmallComponent implements OnInit {
  public rekbots: Rekbot[] = [];
  public filter: FormControl = new FormControl('');
  public oRekbots$: Observable<Rekbot[]> = new Observable<Rekbot[]>();
  public filteredRekbots$: Observable<Rekbot[]> = new Observable<Rekbot[]>();
  public filterValue$: Observable<string> = new Observable<string>();

  public organizationId: number = 0;

  public selectedRekbots: Rekbot[] = [];
  //public selectedRekbotsIds: number[] = [];

  @Input() selectedRekbotsIds: number[] = [];
  @Input() userId: number = 0;


  public organizationRekbots: Rekbot[] = [];


  constructor(
    private rekbotsService: RekbotsService,
    public router: Router,
    private rekbotSelects: RekbotSelectsService,
    private route: ActivatedRoute,

  ) {

    this.oRekbots$ = of(this.rekbots);
    this.filter = new FormControl('');
    this.filterValue$ = this.filter.valueChanges.pipe(startWith(''));

    this.filteredRekbots$ = combineLatest([this.oRekbots$, this.filterValue$]).pipe(
      map(([rekbots, filterValue]) => {
        console.log("mapping filteredRekbots$", rekbots, filterValue)
        return rekbots.filter(rekbot => rekbot.serial_no.toLowerCase().includes(filterValue.toLowerCase()));
      })
    );

    
  }

  ngOnInit(): void {
    this.organizationId = this.route.snapshot.params['organizationId'];
    this.fetchRekbots()
  }

  toggleSelected(rekbot: Rekbot) {
    console.log("toggleSelected", rekbot)

    if (this.selectedRekbotsIds.includes(rekbot.id)) {

      this.rekbotSelects.removeRekbot(rekbot);

      this.selectedRekbots = this.selectedRekbots.filter((el: Rekbot) => {
        return el.id !== rekbot.id;
      });
      this.selectedRekbotsIds = this.selectedRekbotsIds.filter((el: number) => {
        return el !== rekbot.id;
      });

      this.rekbots.find((el: Rekbot) => {
        if (el.id === rekbot.id) {
          el.organization_id = 0;
        }
      })

    } else {
      this.selectedRekbots.push(rekbot);
      this.selectedRekbotsIds.push(rekbot.id);

      this.rekbotSelects.addRekbot(rekbot);

      this.rekbots.find((el: Rekbot) => {
        if (el.id === rekbot.id) {
          el.organization_id = this.organizationId;
        }
      })
    }

    console.log("selectedRekbots", this.selectedRekbots)
    console.log("selectedRekbotsIds", this.selectedRekbotsIds)
  }

  verifySelected(rekbot: Rekbot) {
    //console.log("verifySelected rekbot", rekbot)
    //console.log("verifySelected this.selectedRekbotsIds", this.selectedRekbotsIds)
    if (this.selectedRekbotsIds.includes(rekbot.id)) {
      return true;
    } else {
      return false;
    }
    /*if (rekbot.organization_id == this.userId) {
      return true;
    } else {
      return false;
    }*/
  }

  checkDisabled(rekbot: Rekbot) {
    //console.log("checkDisabled", rekbot, this.organizationId)

    return false;
   
    if (rekbot.organization_id == this.organizationId || rekbot.organization_id == 0 || rekbot.organization_id == null) {
      return false;
    } else {
      return true;
    }
  }

  fetchRekbots(): void {
    this.rekbotsService.fetchRekbots()
      .subscribe({
        next: (response: any) => {

          this.rekbotSelects.selectedRekbots = [];
          this.rekbotSelects.selectedRekbotIds = [];

          this.rekbots = response.map((el: Rekbot) => {
            return el
          })

          this.rekbots.forEach((el: Rekbot) => {
            //console.log("fetchRekbots", el, this.organizationId)
            if( this.selectedRekbotsIds.includes(el.id)) {
              this.rekbotSelects.addRekbot(el);

              //this.selectedRekbots.push(el);
              //this.selectedRekbotsIds.push(el.id);
            }
          });

          console.log("fetchRekbots", this.rekbotSelects.getSelectedRekbotIds(), this.selectedRekbotsIds);

          this.oRekbots$ = of(this.rekbots);
          this.filteredRekbots$ = combineLatest([this.oRekbots$, this.filterValue$]).pipe(
            map(([rekbots, filterValue]) => {
              //console.log("mapping filteredRekbots$", rekbots, filterValue)
              return rekbots.filter(rekbot => rekbot.serial_no.toLowerCase().includes(filterValue.toLowerCase()));
            })
          );
        },
        error: error => {
          console.log("fetchrekbots error", error)
          if (error.status === 401) {
            this.router.navigate(['/']);
          }
        }
      });
  }
}
